import { rem } from "@certn/cascadia";
import { shapes } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";

export function useCheckFlowNavbarStyles() {
  return {
    container: css({
      position: "relative",
      display: "flex",
      flexDirection: "column",
      height: "100%",
    }),
    header: css({
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: `${rem("space-6")} ${rem("space-4")} ${rem("space-6")} ${rem(
        "space-5"
      )}`,
    }),
    title: css({
      display: "flex",
      flexDirection: "column",
    }),
    listContainer: css({
      position: "relative",
      height: "100%",
      padding: `${rem("space-2")} ${rem("space-1")} ${rem("space-2")} ${rem(
        "space-0"
      )}`,
      overflow: "overlay",
      "&::-webkit-scrollbar": {
        width: 3,
      },
      "&::-webkit-scrollbar-track": {
        opacity: 0,
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#D9D9D9",
        borderRadius: 24,
      },
    }),
    list: css({
      display: "grid",
      height: 0,
      gap: rem("space-1"),
      margin: rem("space-0"),
      padding: `${rem("space-0")} ${rem("space-2")}`,
    }),
    listItem: {
      display: "flex",
      alignItems: "center",
      padding: `${rem("space-2")} ${rem("space-3")}`,
    },
    arrowIcon: css({
      position: "absolute",
      bottom: rem("space-2"),
      right: rem("space-2"),
      display: "inline-flex",
      borderRadius: shapes["border-radius-half"],
      padding: rem("space-2"),
    }),
  };
}
